/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_u10m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timing the wind-down period before a short nap so you don't oversleep into deep sleep.`)
};

const es_timer_u10m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cronometrar el período de relajación antes de una siesta corta para no caer en sueño profundo.`)
};

const de_timer_u10m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Runterkommphase vor einem kurzen Nickerchen stoppen, damit du nicht in den Tiefschlaf rutschst.`)
};

const nl_timer_u10m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De aanloopperiode voor een kort dutje timen zodat je niet in diepe slaap doorslaapt.`)
};

const fr_timer_u10m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chronométrer la période de relaxation avant une courte sieste pour ne pas basculer dans le sommeil profond.`)
};

const it_timer_u10m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cronometrare il periodo di relax prima di un breve pisolino per evitare di scivolare nel sonno profondo.`)
};

const pt_br2_timer_u10m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cronometrar o período de relaxamento antes de um cochilo curto para não cair em sono profundo.`)
};

const pt_timer_u10m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cronometrar o período de relaxamento antes de uma soneca curta, para não adormecer demasiado profundamente.`)
};

const ja_timer_u10m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`深い眠りに入りすぎて寝坊しないよう、短い仮眠前のクールダウン時間を計測する。`)
};

const zh_timer_u10m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为短时小睡前的放松阶段计时，避免睡过头进入深度睡眠。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_u10m_use2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_u10m_use2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_u10m_use2", locale)
	if (locale === "en") return en_timer_u10m_use2(inputs)
	if (locale === "es") return es_timer_u10m_use2(inputs)
	if (locale === "de") return de_timer_u10m_use2(inputs)
	if (locale === "nl") return nl_timer_u10m_use2(inputs)
	if (locale === "fr") return fr_timer_u10m_use2(inputs)
	if (locale === "it") return it_timer_u10m_use2(inputs)
	if (locale === "pt-BR") return pt_br2_timer_u10m_use2(inputs)
	if (locale === "pt") return pt_timer_u10m_use2(inputs)
	if (locale === "ja") return ja_timer_u10m_use2(inputs)
	return zh_timer_u10m_use2(inputs)
};